import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewChild, ViewContainerRef } from "@angular/core";
import { AppService } from "@api";
import { FiltroModel } from "@componentes/Filtros/Filtro.model";
import { FiltrosComponent } from "@componentes/Filtros/Filtros.component";
import { TipoFiltroEnum } from "@componentes/Filtros/Filtros.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { ReporteEvaluacionPendienteDetalleComponent } from "./evaluacionpendientedetalle.component";



@Component({
        selector: 'reporteevaluacionpendiente',
        templateUrl: './evaluacionpendiente.component.html',
        styleUrls: ['./evaluacionpendiente.component.scss']
    })

    export class ReporteEvaluacionPendienteComponent implements AfterViewInit{
        consulta!: boolean;
        dataTable!: Array<any>;

        @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
        filtrosDisplay: Array<FiltroModel> = [];
        uriApi: string;

        SelPeriodoevaluacion:any[];
        SelDepartamento:any[];

        @ViewChild("evaluacionpendientedetalle", {read: ViewContainerRef}) evaluacionpendientedetalle!: ViewContainerRef;

        constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){
            this.uriApi = "reporte/evaluacionpendiente/preguntaenviada";
            this.SelPeriodoevaluacion = [];
            this.SelDepartamento = [];
            this.GenerarFiltros();
        }

        ngAfterViewInit() {
            this.LoadDatos().then((respuesta : any)=>{
                this.filtrosComponent.SetFiltros(this.filtrosDisplay, true);
           })
        }

        GenerarFiltros() {
            let filtrosDisplay: Array<FiltroModel> = [];

            filtrosDisplay.push(
                new FiltroModel(
                    {
                        TipoFiltro: TipoFiltroEnum.DropDown,
                        Titulo: 'Periodo evaluación',
                        DisplayValor: 'descripcion',
                        ValorName: 'periodoevaluacionid',
                        Opciones: this.SelPeriodoevaluacion,
                        Propiedad: "periodoevaluacionid",
                        Obligatorio: true,
                        Buscar: true,
                    })
            );
            filtrosDisplay.push(
                new FiltroModel(
                    {
                        TipoFiltro: TipoFiltroEnum.DropDown,
                        Titulo: 'Departamento',
                        DisplayValor: 'nombre',
                        ValorName: 'departamentoid',
                        Opciones: this.SelDepartamento,
                        Propiedad: "departamentoid",
                        Obligatorio: false,
                        Buscar: false,
                    })
            );

            this.filtrosDisplay = filtrosDisplay;
        }

        async LoadDatos(){
            return new Promise((resolve) =>{
                Promise.all([
                this.SetDepartamentoFiltro(),
                this.SetPeriodoevaluacion(),
              ]).then((responses : any) =>{
                return resolve(responses);
              });
            });
          }

        SetPeriodoevaluacion(){
            return new Promise ((resolve) =>{
                this.appService.Post("planeacion/periodoevaluacion/buscar",{}).then(res=>{
                    if(res.status == RespuestaEstatusEnum.Success) {
                        this.SelPeriodoevaluacion = res.data;
                        let filtro:any = this.filtrosDisplay.find(x => x.ValorName == 'periodoevaluacionid');
                        if(filtro){
                            filtro.Opciones = this.SelPeriodoevaluacion;
                            filtro.Valor = this.SelPeriodoevaluacion[0].periodoevaluacionid;
                        }
                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                });
            });
        }

        SetDepartamentoFiltro() {
            return new Promise((resolve : any) =>{
                this.appService.Get("configuracionrh/departamento/usuario").then(res =>{
                    if (res.status == RespuestaEstatusEnum.Success){
                        this.SelDepartamento = res.data;
                        let prueba = {"departamentoid": 0, "nombre": "Todos"}
                        this.SelDepartamento.unshift(prueba)
                        let filtro = this.filtrosDisplay.find(x => x.ValorName == 'departamentoid');
                        if (filtro){
                            filtro.Opciones = this.SelDepartamento;
                        }
                        return resolve(true);
                    }
                    else{
                        return resolve(false);
                    }
                });
            });
        }

        SetDatos(data:any){
            this.dataTable = data;
        }

        prueba(){
            this.consulta = true;
            this.evaluacionpendientedetalle.clear();
            const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ReporteEvaluacionPendienteDetalleComponent);
            var ref: ComponentRef<any> = this.evaluacionpendientedetalle.createComponent(factory);
            ref.instance.accion = {accionid: 1, accion: "colaboradores"};
            ref.instance.output.subscribe((cambio: boolean) => {
                this.consulta = false;
                ref.destroy();
            });
        }

        //Formulario para validar que accion se va arealizar y mandar la informacion a la nueva pantalla
        Formulario(accionid: number, entidad: any) {
            let accion: string = ""
            switch (accionid) {
                case 1:
                    accion = "Colaboradores";
                    break;
                case 2:
                    accion = "Padre";
                    break;
                case 3:
                    accion = "Alumno";
                    break;
            }
            this.cargarContenedorFormulario({accionid: accionid, accion: accion, entidad: entidad});
        }

        //Carga el contenedor con la informacion de la nueva pantalla
        cargarContenedorFormulario(data: {accionid: number, accion: string, entidad: any}) {
            this.consulta = true;
            this.evaluacionpendientedetalle.clear();
            const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ReporteEvaluacionPendienteDetalleComponent);
            var ref: ComponentRef<any> = this.evaluacionpendientedetalle.createComponent(factory);
            ref.instance.entidad = data.entidad;
            ref.instance.accion = {accionid: data.accionid, accion: data.accion};
            ref.instance.output.subscribe((cambio: boolean) => {
                this.consulta = false;
                ref.destroy();
            });
        }
    }
